// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/CampaignChatPrivacyBanner.test.tsx

import { useTranslation } from "react-i18next";

/**
 * Callout shown above a private project chat thread. Explains that the
 * conversation is visible only to the current user until promoted. The
 * primary "Share to project" control lives in `CampaignChatDetailHeader`.
 */
export function CampaignChatPrivacyBanner() {
  const { t } = useTranslation("ui");

  return (
    <div
      className="shrink-0 border-b border-puntt-neutral-gray-5 bg-puntt-neutral-gray-1 px-4 py-3"
      data-testid="campaign-chat-privacy-banner"
      role="status"
    >
      <p className="mx-auto max-w-[720px] text-[13px] leading-snug text-puntt-neutral-gray-11">
        {t("campaignChatPrivacyBanner.message")}
      </p>
    </div>
  );
}
